import React, { useState, useEffect } from 'react';
import styles from './overlay.module.css';
import { Autocomplete, TextField, Chip, Snackbar, Box } from '@mui/material';
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import Alert from '@material-ui/lab/Alert';
import DeleteUserModal from './deleteUserModal';
import { useSelector } from "react-redux";
import { withStyles } from '@material-ui/core/styles';

const CssTextField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "#0F9BB0"
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#0F9BB0"
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#0F9BB0"
            },
            "&:hover fieldset": {
                borderColor: "#0F9BB0"
            },
            "&.Mui-focused fieldset": {
                borderColor: "#0F9BB0"
            }
        },
        "& .MuiFormLabel-root.Mui-error": {
            color: "gray !important",
        },
        "& .MuiFormHelperText-root.Mui-error": {
            color: "red !important"
        },
        "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "black",
            color: "black"
        }
    },
})(TextField);

export default function Users() {
    const axios = useAxiosPrivate()
    const role = useSelector((state) => state.auth.role);
    const [emails, setEmails] = useState([]);
    const [admins, setAdmins] = useState([]);
    const [opened, setOpened] = useState(false);
    const [id, setID] = useState('');
    const [emailsValidation, setEmailsValidation] = useState([]);

    const [alert, setAlert] = useState({
        showAlert: false,
        severity: 'success',
        message: '',
    });

    const addEmails = (arr) => {
        let testArray = [];
        setEmails(arr);
        arr.map((item) => {
            const result = checkEmail(item);
            if (result) {
                return testArray.push(true);
            } else {
                return testArray.push(false);
            }
        })
        setEmailsValidation(testArray);
    };

    const sendInvite = () => {
        if (emails.length === 0) {
            setAlert({
                showAlert: true,
                severity: 'error',
                message: 'Please enter an email address and press ENTER to invite.',
            });
        }
        emails.map(async (item) => {
            try {
                await axios.post('/user/invite', {
                    email: item,
                });
                setAlert({
                    showAlert: true,
                    severity: 'success',
                    message: 'Sent invite Successfully!',
                });
                window.location.href = '/users';
            } catch (error) {
                if (error.response.status === 401) {
                    setAlert({
                        showAlert: true,
                        severity: 'error',
                        message: 'Invalid Authentication!',
                    });
                } else if (error.response.status === 404) {
                    setAlert({
                        showAlert: true,
                        severity: 'error',
                        message: 'User not found.!',
                    });
                } else if (error.response.status === 400) {
                    setAlert({
                        showAlert: true,
                        severity: 'error',
                        message: "User with email address already exist.",
                    });
                } else {
                    setAlert({
                        showAlert: true,
                        severity: 'error',
                        message: 'Server error!',
                    });
                }
            }
        });
    };

    const checkEmail = (address) => {
        let regex = new RegExp(
            // eslint-disable-next-line
            "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])"
        );
        return regex.test(address);
    };

    const loadData = async () => {
        const { data } = await axios.get('/team/admins');
        setAdmins(data.data);
    }

    const handleDelete = (id) => {
        setID(id);
        setOpened(true)
    }

    useEffect(() => {
        loadData();
        // eslint-disable-next-line
    }, [])

    const handleClose = () => {
        setAlert({
            showAlert: false,
            severity: "success",
            message: "",
        })
    };

    return (
        <div style={{ backgroundColor: 'white', height: 1000, marginTop: "-2rem" }}>
            <p className={styles.headerText}>Invite Your Dashboard Users</p>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 2rem' }}>
                <div style={{ width: '57%' }}>
                    <Autocomplete
                        multiple
                        freeSolo
                        fullWidth
                        onChange={(event, newValue) => {
                            addEmails(newValue);
                        }}
                        options={[]}
                        getOptionLabel={(option) => option}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <>
                                    {checkEmail(option) ? (
                                        <div className={styles.emailChip}>
                                            <Chip
                                                style={{
                                                    fontFamily: 'normal normal normal 12px Poppins',
                                                    letterSpacing: '0px',
                                                    background: '#ECF9F7 0% 0% no-repeat padding-box',
                                                    color: '#000000',
                                                    opacity: 1,
                                                    flexWrap: 'wrap',
                                                    fontWeight: 400,
                                                    fontSize: '1rem',
                                                    lineHeight: '1.37rem',
                                                    height: "2rem"
                                                }}
                                                key={index}
                                                size='small'
                                                label={option}
                                                {...getTagProps({ index })}
                                            />
                                        </div>
                                    ) : (
                                        <div className={styles.errorChip}>
                                            <Chip
                                                style={{
                                                    fontFamily: 'normal normal normal 12px Poppins',
                                                    letterSpacing: '0px',
                                                    background: '#ffffff 0% 0% no-repeat padding-box',
                                                    color: '#000000',
                                                    opacity: 1,
                                                    flexWrap: 'wrap',
                                                    fontWeight: 400,
                                                    fontSize: '1rem',
                                                    lineHeight: '1.37rem',
                                                    height: "1.5rem"
                                                }}
                                                key={index}
                                                size='small'
                                                label={option}
                                                {...getTagProps({ index })}
                                            />
                                        </div>
                                    )}
                                </>
                            ))
                        }
                        renderInput={(params) => (
                            <CssTextField
                                placeholder={
                                    params ? 'Insert email to add dashboard users, divide by enter' : ''
                                }
                                {...params}
                            />
                        )}
                    />
                </div>

                <input
                    type='button'
                    className={
                        emails.length > 0 && !emailsValidation.includes(false) ? styles.searchButton : styles.disabled
                    }
                    value='Send Invite'
                    onClick={emails.length > 0 && !emailsValidation.includes(false) ? sendInvite : null}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', padding: '0 2rem' }}>
                <div style={{
                    width: '57%',
                    marginTop: '1rem',
                    marginBottom: '4rem',
                    padding: '1.8rem',
                    backgroundColor: '#E9F1F1'
                }}>
                    <Box sx={{ height: 500, overflowY: "auto" }}>
                        <p className={styles.descriptionTittle}>People who are invited will receive a link to create an
                            account and be able to use the dashboard. </p>
                        {admins.map((admin) => (
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <p className={styles.emailPara}>{admin.email}</p>
                                {role === "SUPER_ADMIN" &&
                                    <p className={styles.emailDelete} onClick={() => { handleDelete(admin?.id) }}>Delete</p>
                                }
                            </div>
                        ))}
                    </Box>
                </div>
                <div style={{ width: '117px', margin: '5px' }}></div>
            </div>
            <Snackbar
                open={alert.showAlert}
                autoHideDuration={4000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    severity={alert.severity}
                    onClose={handleClose}
                >
                    {alert.message}
                </Alert>
            </Snackbar>
            <DeleteUserModal setOpen={setOpened} open={opened} id={id} setAlert={setAlert} loadData={loadData} />
        </div>
    );
}
